export default __webpack_public_path__ + "static/media/rain-snow-showers-night.0de1d5a5.svg";